import React, { useState } from 'react'
import { Row, Container, Card, ListGroup, Breadcrumb, InputGroup, FormControl } from 'react-bootstrap'
import HeaderSupport from '../../Components/HeaderSupport'
import Bannersupport from '../../Assets/TempExample//ExampleGuides.png'
import ImageIconLoader from '../../Components/ImageIconLoader'
import Footer from '../../Components/FooterSupport'

const Index: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const handleSearch = (event: any) => {
    const term = event.target.value;
    setSearchTerm(term);
    if (term === '') {
    } else {
    }
  };
  return (
    <div className='position-relative'>
      <HeaderSupport />
      <div className='guides_banner'>
        <div className="guides_banner-container container-fluid ">
          <div className='px-4 col-4'>
            <div className='mx-3'>
              <Breadcrumb>
                <Breadcrumb.Item href="#">Suport</Breadcrumb.Item>
                <Breadcrumb.Item active>Product Updates</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div>
              <h1 className=' text-white'>
                Product Updates
              </h1>
              <p className='text-white'>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod.
              </p>
              <InputGroup className="search-input">
                <FormControl
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <InputGroup.Text className="search-icon">
                  <ImageIconLoader name={"iconsearch"} alt="" width={30} />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>

        </div>

      </div>
      <Container fluid>
        {['PES Markets', 'Predict Program Size', 'Geotargeting'].map((item) => (
          <section className='p-4'>

          </section >
        ))}
      </Container>

      <Footer />

    </div >
  )
}

export default Index